// TanStack Router set-up for the operations console.
//
// Single-page today, but using the typed router keeps the door open to e.g.
// an /events detail page without rewriting navigation or providers. We
// construct + render the official TanStack <RouterProvider> here; our export
// is named <DashboardRouterProvider> to avoid colliding with the imported
// component in the global JSX scope.
import {
  createRouter,
  createRootRouteWithContext,
  createRoute,
  RouterProvider as TanStackRouterProvider,
  Outlet,
} from '@tanstack/react-router'
import { OperationsRoute } from './routes/operations-route'
import { ChatRoute } from './routes/chat-route'
import { ModelsRoute } from './routes/models-route'
import { ChannelsRoute } from './routes/channels-route'
import { ApiKeysRoute } from './routes/api-keys-route'
import { IntegrationsRoute } from './routes/integrations-route'
import { SettingsRoute } from './routes/settings-route'

import { AppShell } from './components/app-shell'

interface RouterContext {
  // Reserved for future context injection; intentionally minimal.
}

function RootLayout() {
  return <AppShell><Outlet /></AppShell>
}

const rootRoute = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
})

const operationsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  component: OperationsRoute,
})

const chatRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/chat',
  component: ChatRoute,
})

const modelsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/models',
  component: ModelsRoute,
})

const channelsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/channels',
  component: ChannelsRoute,
})

const apiKeysRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/api-keys',
  component: ApiKeysRoute,
})

const integrationsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/integrations',
  component: IntegrationsRoute,
})

const settingsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings',
  component: SettingsRoute,
})

const routeTree = rootRoute.addChildren([operationsRoute, chatRoute, modelsRoute, channelsRoute, apiKeysRoute, integrationsRoute, settingsRoute])
const router = createRouter({ routeTree })

export function RouterProvider() {
  return <TanStackRouterProvider router={router} />
}
